<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	//判斷ip地址
	let resData = '';
	export default {
		name: 'app',
		components: {

		},
		watch: {
			$route() {
				// console.log( 1111, resData )
				if ( resData.areaCode == 1 && this.$route.path != '/cannotAccess' ) {
					this.$router.push( {
						name: 'cannotAccess'
					} )
				}
			}
		},
		mounted() {
			// console.log( 3333, resData )
			try {
				const script = document.createElement( 'script' )
				script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
				script.language = 'JavaScript'
				document.body.appendChild( script )
			} catch ( e ) {
				//TODO handle the exception
			}

			this.$MyAxios.get( `/api/accounts/ipAddr`, res => {
				resData = res.data
				console.log( 2222, resData )
				// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
				if ( resData.areaCode == 1 ) {
					this.$router.push( {
						name: 'cannotAccess'
					} )
				}
			}, err => {
				resData = err.data
				console.log( 444, resData )
				// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
				if ( resData.areaCode == 1 ) {
					this.$router.push( {
						name: 'cannotAccess'
					} )
				}
			} )
		}
	}
</script>

<style lang="less">
	@import "./style/common";

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100%;
		position: relative;
	}
</style>